import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { ClickEventDirective } from '@df/ui/common/click-event.directive';
import { ValuesPipe } from '@df/ui/common/values.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { BasketDiscountButtonsComponent } from '../../basket/basket-discount-buttons.component';
import { CouponRemoveComponent } from '../../basket/coupon-remove.component';
import { FreeShippingBlockComponent } from '../../basket/free-shipping-block/free-shipping-block.component';
import { BasketReturnMessageComponent } from '../../catalog/ui/basket/basket-return-message.component';
import { BraintreeApplePayExpressBasketComponent } from '../../module/braintree/apple-pay/braintree-apple-pay-express-basket.component';
import { GiftcardsAddedGiftcardComponent } from '../../module/giftcards/giftcards-added-giftcard.component';
import { StoreCreditRemoveComponent } from '../../module/store-credit/remove/store-credit-remove.component';
import { ResultComponent } from '../../ui/api/result.component';
import { BasketFastCheckoutStepComponent } from './basket-fast-checkout-step.component';
import { LocalFastCheckoutFormComponentDef } from './local-fast-checkout-form.component.def';

export const BASKET_FAST_CHECKOUT_LOADED_EVENT_NAME = 'basket-fast-checkout.loaded';

@Component({
    selector: 'basket-fast-checkout-form',
    templateUrl: './basket-fast-checkout-form.html',
    standalone: true,
    imports: [
        BasketDiscountButtonsComponent,
        BasketFastCheckoutStepComponent,
        BasketReturnMessageComponent,
        BraintreeApplePayExpressBasketComponent,
        ClickEventDirective,
        CommonModule,
        CouponRemoveComponent,
        FreeShippingBlockComponent,
        GiftcardsAddedGiftcardComponent,
        PriceComponent,
        ResultComponent,
        RouterModule,
        StoreCreditRemoveComponent,
        TranslatePipe,
        ValuesPipe
    ]
})
export class BasketFastCheckoutFormComponent extends LocalFastCheckoutFormComponentDef {
    @Input()
    canGoNextStep = false;

    protected override onLoad(result: Checkout.IData): void {
        super.onLoad(result);
        this.app.events.broadcast(BASKET_FAST_CHECKOUT_LOADED_EVENT_NAME);
    }
}
